/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationFormOfWork } from './DriverRegistrationFormOfWork';
import type { DriverRegistrationLogLastStep } from './DriverRegistrationLogLastStep';
import type { DriverOperatingModel } from './DriverOperatingModel';
import type { DriverRegistrationLogType } from './DriverRegistrationLogType';
import type { Gender } from './Gender';
import type { StructuredAddress } from './StructuredAddress';
import type { TaxIdentificationNumber } from './TaxIdentificationNumber';
import type { DriverRegistrationLogLicenseTypeSelection } from './DriverRegistrationLogLicenseTypeSelection';
import type { GenericField } from './GenericField';
import type { DriverRegistrationVehicleTypeSelection } from './DriverRegistrationVehicleTypeSelection';

export interface DriverSignupData {
    account_branch_code?: string | null;
    birthday?: string | null;
    referral_code?: string;
    car_color?: string;
    car_license_plate?: string;
    car_model_id?: number | null;
    car_transport_license_number?: string;
    car_vin?: string;
    driver_license?: string;
    first_name?: string;
    gender?: Gender | null;
    has_car?: boolean;
    has_taxi_license?: boolean;
    taxi_license?: string;
    language?: string;
    last_name?: string;
    personal_code?: string;
    car_year?: number;
    billing_type?: DriverRegistrationLogType | null;
    company_name?: string;
    address?: string;
    reg_code?: string;
    company_is_liable_to_vat?: boolean;
    vat_code?: string;
    beneficiary_name?: string;
    iban?: string | null;
    swift?: string;
    allow_fleet_matching?: boolean;
    province_id?: number;
    license_type_selection?: DriverRegistrationLogLicenseTypeSelection | null;
    generic_fields?: Array<GenericField>;
    /** 2 char country code, for example: \'us\', \'ee\', \'gb\' */
    country_of_birth?: string;
    tax_identification_numbers?: Array<TaxIdentificationNumber>;
    transport_operator_name?: string;
    transport_operator_number?: string;
    form_of_work?: DriverRegistrationFormOfWork | null;
    mailing_address?: string;
    structured_address?: StructuredAddress | null;
    structured_mailing_address?: StructuredAddress | null;
    operating_model_selection?: DriverOperatingModel | null;
    has_marketing_consent?: boolean;
    vehicle_type_selection?: DriverRegistrationVehicleTypeSelection | null;
    last_step: DriverRegistrationLogLastStep;
}
